/* eslint-disable no-unused-vars*/
import auth from '../services/auth';
import router from '../setup/router';

export default {
  namespaced: true,
  state: {
    authorised: !!localStorage.getItem('whizeo-internal-token'),
    token: localStorage.getItem('whizeo-internal-token') || '',
    admin: false
  },
  mutations: {
    AUTH_SUCCESS(state, token) {
      state.authorised = true;
      localStorage.setItem('whizeo-internal-token', token);
      state.token = token;
    },
    AUTH_LOGOUT(state) {
      state.authorised = false;
      state.token = '';
      router.push('/Login');
    }
  },
  getters: {
    isAuthenticated(state) {
      return state.authorised;
    },
  },
  actions: {
    async AUTH_LOGIN({ commit }, user) {
      try {
        const response = await auth.login(user);
        commit('AUTH_SUCCESS', response.token);
      } catch {
        localStorage.removeItem('whizeo-internal-token');
        this.dispatch('whizeosupportToolsStore/SHOW_SNACKBAR', { message: 'Please check your details and try again', color: 'error', visible: true });
      }
    },
    AUTH_LOGOUT({ commit }) {
      localStorage.removeItem('whizeo-internal-token');
      localStorage.removeItem('whizeo-user');
      commit('AUTH_LOGOUT');
    },
  },
}